import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { OAuthService, OAuthEvent } from 'angular-oauth2-oidc';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        //private authService: AuthService,
        private authService: OAuthService
    ) {

    }

    canActivate() {
      console.log('AuthGuard#canActivate called a', this.authService.hasValidIdToken(), this.authService.hasValidAccessToken());
    if (this.authService.hasValidAccessToken())
      return true;

    this.authService.events.subscribe(({ type }: OAuthEvent) => {
        console.log('event', type);
      switch (type) {
        case 'token_received':
          return this.router.navigate(['/protected-route']); // How to get the actually route?
      }
    });

    this.authService.initLoginFlow();

    return false;
/*
        this.oauthService.initLoginFlow();
        if (!this.authService.isLoggedIn()) {
            this.router.navigate(['/auth/login']);
            return false;
        } else {
            return true;
        }
        */
    }
}
